module.exports = __webpack_public_path__ + "img/programs-bg.c47fc6ed.png";